module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_7005.b2597961.png";